import Weather from "./Weather";
import Footer from "./Footer";

import "./App.css";

function App() {
  let name = prompt("What is your name?");

  return (
    <div className="App">
      <header className="App-header">
        <div className="card">
          <div className="container">
            <h1>Hello, {name}</h1>
            <Weather defaultCity="New York" className="mb-5" />
          </div>
        </div>
        <Footer />
      </header>
    </div>
  );
}

export default App;
